import {
    createFolderFiles, deleteFolderFiles, deleteFolderFilesCustomer, getAllFolderFiles, getAllFolderFilesCustomer, getFilesDownloadService, getFolderFilesService, uploadFolderFiles
  } from '../../services/folderSectionServices';

  import {
    CREATE_FOLDER_FILES_FAILURE, CREATE_FOLDER_FILES_SUCCESS,
    DELETE_FOLDER_FILES_FAILURE,
    GET_ALL_FOLDER_FILES_FAILURE, GET_ALL_FOLDER_FILES_SUCCESS,
    UPLOAD_FOLDER_FILES_FAILURE, UPLOAD_FOLDER_FILES_SUCCESS, START_LOADING, STOP_LOADING,
    GET_FOLDER_FILES_SUCCESS,
    GET_FOLDER_FILES_FAILURE,
    GET_FILES_DOWNLOAD_SUCCESS,
    GET_FILES_DOWNLOAD_FAILURE,
    RESET_FOLDER_FILES
  } from './actionTypes';

  // import { openSessionTimeoutModal } from './sessionTimeOutActions';

  export const uploadFolderFilesAction = (formData, callbackfn) => async (dispatch, getState) => {
    try {

        dispatch({ type: START_LOADING, service: 'UPLOAD_FOLDER_FILES' });

        // Retrieve the token
        const token = getState().auth.token || sessionStorage.getItem("token");


        // Making the API call
        const response = await uploadFolderFiles(formData, token);


        // Check if response is an array or an object
        if (!response || (Array.isArray(response) && response.length === 0)) {

            throw new Error("Invalid response from uploadFolderFiles API.");
        }

        // If the response is an array, we directly use it; otherwise, check response.data
        const payload = Array.isArray(response) ? response : response.data;

        // Dispatch the success action
        dispatch({ type: UPLOAD_FOLDER_FILES_SUCCESS, payload: payload });

        // Execute the callback function if provided
        if (callbackfn) {

            callbackfn(payload);
        }
    } catch (error) {

        dispatch({
            type: UPLOAD_FOLDER_FILES_FAILURE,
            payload: error.message || 'Upload folder files service failed. Please try again.'
        });
    } finally {
        setTimeout(() => {
          dispatch({ type: STOP_LOADING, service: 'UPLOAD_FOLDER_FILES' });
        }, 5);
    }
};


  // export const createFolderFilesAction = (formData, callbackfn) => async (dispatch, getState) => {
  //   try {
  //       dispatch({ type: START_LOADING, service: 'CREATE_FOLDER_FILES' });

  //       const token = getState().auth.token || sessionStorage.getItem("token");
  //       const response = await createFolderFiles(formData, token);

  //       dispatch({ type: CREATE_FOLDER_FILES_SUCCESS, payload: response });

  //       if (callbackfn) {
  //           callbackfn(response);
  //       }
  //   } catch (error) {
  //       dispatch({
  //           type: CREATE_FOLDER_FILES_FAILURE,
  //           payload: error || 'Create folder files service failed. Please try again.'
  //       });
  //   } finally {
  //       dispatch({ type: STOP_LOADING, service: 'CREATE_FOLDER_FILES' });
  //   }
  // };

  export const createFolderFilesAction = (formData, callbackfn) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: "CREATE_FOLDER_FILES" });

        const token = getState().auth.token || sessionStorage.getItem("token");

        // Ensure policyId is a valid number
        // const policyId = Number(formData.policyId) || getState().policy.currentPolicyId || 0;

        // if (!policyId) {
        //   throw new Error("Invalid or missing policy ID.");
        // }

        // let formattedData = {
        //   folderName: formData.folderName,
        //   policyId,
        //   isSubFolder: !!formData.isSubFolder // Convert to boolean
        // };

        // if (formData.isSubFolder) {
        //   formattedData = {
        //     ...formattedData,
        //     parentFolderId: formData.parentFolderId,
        //     parentFolderName: formData.parentFolderName
        //   };
        // }

        const response = await createFolderFiles(formData, token);

        dispatch({ type: CREATE_FOLDER_FILES_SUCCESS, payload: response });

        if (callbackfn) {
          callbackfn(response);
        }

        return response; // Return the response for async handling
      } catch (error) {
        dispatch({
          type: CREATE_FOLDER_FILES_FAILURE,
          payload: error?.message || "Create folder files service failed. Please try again."
        });
        throw error; // Propagate the error to the calling function
      } finally {
        setTimeout(() => {
          dispatch({ type: STOP_LOADING, service: 'CREATE_FOLDER_FILES' });
        }, 5);
      }
    };




    export const getAllFolderFilesAction = (policyId, page = 0, size = 100) => async (dispatch, getState) => {

      try {
        dispatch({ type: START_LOADING, service: 'GET_ALL_FOLDER_FILES' });

        const token = getState().auth.token || sessionStorage.getItem("token");

        const response = await getAllFolderFiles(policyId, page, size, token);

        // Save the complete folder structure to the Redux state
        dispatch({ type: GET_ALL_FOLDER_FILES_SUCCESS, payload: response?.data || [] });

        return response;
      } catch (error) {

          dispatch({
            type: GET_ALL_FOLDER_FILES_FAILURE,
            payload: error?.message || 'Get all folder files service failed. Please try again.'
          });
      } finally {
        setTimeout(() => {
          dispatch({ type: STOP_LOADING, service: 'GET_ALL_FOLDER_FILES' });
        }, 5);
      }
    };

    export const getAllFolderFilesCustomerAction = (clientCustomerId, page = 0, size = 100) => async (dispatch, getState) => {

      try {
        dispatch({ type: START_LOADING, service: 'GET_ALL_FOLDER_FILES' });

        const token = getState().auth.token || sessionStorage.getItem("token");

        const response = await getAllFolderFilesCustomer(clientCustomerId, page, size, token);

        // Save the complete folder structure to the Redux state
        dispatch({ type: GET_ALL_FOLDER_FILES_SUCCESS, payload: response?.data || [] });

        return response;
      } catch (error) {

          dispatch({
            type: GET_ALL_FOLDER_FILES_FAILURE,
            payload: error?.message || 'Get all folder files service failed. Please try again.'
          });
      } finally {
        setTimeout(() => {
          dispatch({ type: STOP_LOADING, service: 'GET_ALL_FOLDER_FILES' });
        }, 5);
      }
    };
    export const getFolderFilesAction = (folderId, page = 0, size = 5) => async (dispatch, getState) => {
      try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });

          // Fetch the token from state or session storage
          const token = getState().auth.token || sessionStorage.getItem("token");

          // Pass the fetched token to the service
          const response = await getFolderFilesService(folderId,token, page, size);
          //  console.log("response",response)

          dispatch({ type: GET_FOLDER_FILES_SUCCESS, payload: response || [] });


          return response || [];

      } catch (error) {

          // Dispatch failure action with error message
          dispatch({
              type: GET_FOLDER_FILES_FAILURE,
              payload: error?.message || 'Get folder files service failed. Please try again.'
          });

          // Return empty array instead of throwing error to prevent UI crashes
          return [];
      } finally {
          setTimeout(() => {
            dispatch({ type: STOP_LOADING, service: 'GET_FOLDER_FILES' });
          }, 5);
      }
  };


  export const getFilesDownloadAction = (id, download = false) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });

        // Fetch the token from state or session storage
        const token = getState().auth.token || sessionStorage.getItem("token");

        // Pass the fetched token to the service
        const response = await getFilesDownloadService(id,token,download);
        //  console.log("response",response)

        dispatch({ type: GET_FILES_DOWNLOAD_SUCCESS, payload: response || [] });


        return response || [];

    } catch (error) {

        // Dispatch failure action with error message
        dispatch({
            type: GET_FILES_DOWNLOAD_FAILURE,
            payload: error?.message || 'Get folder files service failed. Please try again.'
        });

        // Return empty array instead of throwing error to prevent UI crashes
        return [];
    } finally {
        setTimeout(() => {
          dispatch({ type: STOP_LOADING, service: 'GET_FOLDER_FILES' });
        }, 5);
    }
};





export const deleteFolderFilesByFolderIdAction = (folderId, policyId, folderPath) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'DELETE_FOLDER_FILES' });

    const token = getState().auth.token || sessionStorage.getItem("token");

   const response= await deleteFolderFiles(folderId, policyId, folderPath, token);

    // dispatch({ type: DELETE_FOLDER_FILES_SUCCESS, payload: { folderId } });

    // if (callbackfn) {
    //   callbackfn(folderId);
    // }
    return response;
  } catch (error) {
    dispatch({
      type: DELETE_FOLDER_FILES_FAILURE,
      payload: error.message || 'Delete folder files service failed. Please try again.'
    });
  } finally {
    setTimeout(() => {
      dispatch({ type: STOP_LOADING, service: 'DELETE_FOLDER_FILES' });
    }, 1);
  }
};

export const deleteFolderFilesByCustomerFolderIdAction = (folderId, customerId, folderPath) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'DELETE_FOLDER_FILES' });

    const token = getState().auth.token || sessionStorage.getItem("token");

   const response= await deleteFolderFilesCustomer(folderId, customerId, folderPath, token);

    // dispatch({ type: DELETE_FOLDER_FILES_SUCCESS, payload: { folderId } });

    // if (callbackfn) {
    //   callbackfn(folderId);
    // }
    return response;
  } catch (error) {
    dispatch({
      type: DELETE_FOLDER_FILES_FAILURE,
      payload: error.message || 'Delete folder files service failed. Please try again.'
    });
  } finally {
    setTimeout(() => {
      dispatch({ type: STOP_LOADING, service: 'DELETE_FOLDER_FILES' });
    }, 1);
  }
};

export const resetFolderFiles = () => ({
  type: RESET_FOLDER_FILES
});
